import { c as _c } from "react/compiler-runtime";
import { FaroTextButton } from "@components/common/faro-text-button";
import { BulkRemoveMemberDialog } from "@components/table/members/bulk-actions/bulk-remove-member-dialog";
import { useState } from "react";
import { getBulkActionButtonConfig } from "@components/common/faro-table/bulk-actions/bulk-actions-config";
import { Text, DeleteIcon } from "@flat-ui";
import { useBulkActionsMode } from "@hooks/use-bulk-actions-mode";

/** Props for the bulk remove member button */

/** Show remove member button and dispatch action where the bulk dialog will act accordingly */
export function BulkRemoveMember(t0) {
  const $ = _c(25);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      title: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const title = t1 === undefined ? "Remove members" : t1;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const mode = useBulkActionsMode();
  const t2 = `Remove member from ${props.subjectType}`;
  let t3;
  if ($[3] !== mode || $[4] !== t2) {
    t3 = getBulkActionButtonConfig(mode, t2);
    $[3] = mode;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const config = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsDialogOpen(true);
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== config.sx) {
    t5 = {
      ...config.sx
    };
    $[7] = config.sx;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <DeleteIcon sx={{
      width: "18px",
      height: "18px"
    }} />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== config.shouldShowText || $[11] !== title) {
    t7 = config.shouldShowText && <Text variant="buttonM">{title}</Text>;
    $[10] = config.shouldShowText;
    $[11] = title;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== config.rippleColor || $[14] !== config.tooltipText || $[15] !== t5 || $[16] !== t7) {
    t8 = <FaroTextButton onClick={t4} tooltipText={config.tooltipText} sx={t5} startIcon={t6} rippleColor={config.rippleColor}>{t7}</FaroTextButton>;
    $[13] = config.rippleColor;
    $[14] = config.tooltipText;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const t9 = props;
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setIsDialogOpen(false);
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== isDialogOpen || $[20] !== t9) {
    t11 = <BulkRemoveMemberDialog {...t9} isOpen={isDialogOpen} onClose={t10} />;
    $[19] = isDialogOpen;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t8) {
    t12 = <>{t8}{t11}</>;
    $[22] = t11;
    $[23] = t8;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
}